enum Actions {
  fetchFeaturedUsers = 'fetchFeaturedUsers',
  fetchUsers = 'fetchUsers',
  clearUsers = 'clearUsers',
  fetchRankedUsers = 'fetchRankedUsers',
  clearRankedUsers = 'clearRankedUsers',
}

export default Actions;
